import React  from 'react';
import {Link, NavLink} from 'react-router-dom';
/*import React, {useState, useEffect, useCallback}  from 'react';
import {Link, NavLink, useNavigate, useParams} from 'react-router-dom';*/
import styled from 'styled-components';

import Logo from './../../common/components/Logo';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  *{
    text-decoration: none !important;
  }
`;
const Top = styled.div.withConfig({displayName:'-Top'})`
  height: 140px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const Content = styled.div.withConfig({displayName:'-Content'})`
  padding: 20px;
`;

const Item = styled.div.withConfig({displayName:'-Item'})`
  font-family: 'Roboto',cursive;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 5px;
  text-decoration: none !important;

  color: ${props => props.isActive ? "#0D609D" : "#ffffff"};
  background-color: ${props => props.isActive ? "#ffffff" : "#0D609D"};

  &:hover{
    color: #0D609D;
    background-color: #ffffff;
  }
`;
const IconWrapper = styled.div.withConfig({displayName:'-IconWrapper'})`
  display: inline-grid;
  margin-right: 8px;
`;
const Text = styled.div.withConfig({displayName:'-Text'})`
  font-size: bold;
  font-size: 18px;
`;

/*
const SelectProjectContainer = styled.div.withConfig({displayName:'-SelectProjectContainer'})`
  display: flex;
  flex-direction: row;
`;
const SelectProjectIcon = styled.div.withConfig({displayName:'-SelectProjectIcon'})`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-right: 6px;
  margin-left: -12px;
`;
const SelectProjectText = styled.div.withConfig({displayName:'-SelectProjectText'})`
`;
const SelectProjectName = styled.div.withConfig({displayName:'-SelectProjectName'})`
  font-weight: 600;
  font-size: 12px;
`;
const SelectProjectUuid = styled.div.withConfig({displayName:'-SelectProjectUuid'})`
  font-weight: 400;
  font-size: 10px;
`;
*/

const Sidebar = () => {

  /*
  const navigate = useNavigate();
  const { projectUuid } = useParams();

  const [currentProject, setCurrentProject] = useState(projectUuid ? projectUuid : null);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    ProjectsService.getAll().then((response) => {
      if(response.success){
        setProjects(response.data);
      }else{
        console.log(response.error);
      }
    });
  }, []);

  const changeProject = useCallback((val) => {
    setCurrentProject(val.value);
    navigate("/"+val.value+"/dashboard");
  }, [navigate]);

 */
  return (
    <Wrapper>
      <Top>
        <Link to="/">
          <Logo inverse height="70px" />
        </Link>
      </Top>
      <Content>

        <Wrapper>
          <NavLink to={"/admin/"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                  <i className="fa-solid fa-gauge"></i>
                </IconWrapper>
                <Text>
                  Dashboard
                </Text>
              </Item>
            )}
          </NavLink>
          {/*
          <NavLink to={"/admin/siti"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                 <i className="fa-solid fa-location-crosshairs"></i>
                </IconWrapper>
                <Text>
                  Siti
                </Text>
              </Item>
            )}
          </NavLink>
          <NavLink to={"/admin/macrolotti"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                 <i className="fa-solid fa-draw-polygon"></i>
                </IconWrapper>
                <Text>
                  Macrolotti
                </Text>
              </Item>
            )}
          </NavLink>
          <NavLink to={"/admin/subaree"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                 <i className="fa-solid fa-cubes-stacked"></i>
                </IconWrapper>
                <Text>
                  Subaree
                </Text>
              </Item>
            )}
          </NavLink>
          */}
          <NavLink to={"/admin/rapporti-prova"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                 <i className="fa-solid fa-cubes-stacked"></i>
                </IconWrapper>
                <Text>
                  Rapporti di Prova
                </Text>
              </Item>
            )}
          </NavLink>
          <NavLink to={"/admin/users"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                 <i className="fa-solid fa-users"></i>
                </IconWrapper>
                <Text>
                  Utenti
                </Text>
              </Item>
            )}
          </NavLink>
          {/* <NavLink to={"/admin/events"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                  <Icon name={"events"} color={"#ffffff"} size="25px" />
                </IconWrapper>
                <Text>
                  Eventi
                </Text>
              </Item>
            )}
          </NavLink>
          <NavLink to={"/admin/adoption-applications"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                  <Icon name={"events"} color={"#ffffff"} size="25px" />
                </IconWrapper>
                <Text>
                  Candidature adozione
                </Text>
              </Item>
            )}
          </NavLink>
          <NavLink to={"/admin/cession-applications"} exact="true">
            {({ isActive }) => (
              <Item isActive={isActive}>
                <IconWrapper>
                  <Icon name={"events"} color={"#ffffff"} size="25px" />
                </IconWrapper>
                <Text>
                  Candidature cessione
                </Text>
              </Item>
            )}
          </NavLink> */}

        </Wrapper>

      </Content>
    </Wrapper>
  )
}

export default Sidebar;
